import {ref} from 'vue';

const darkMode = ref(false);

export {
    darkMode
};